import React from "react";
import { useQueryClient, useMutation,useQuery } from "react-query";
import { addUser, getAuthVerificationMethod, getCustomerDetailsforSingup, getVerificationMethod } from "services/user.service";

export const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation((User) => addUser(User), {
    onSuccess: (res) => {
      queryClient.invalidateQueries("users");
    },
    // onError: (error) => {
    //   if (error.response && error.response.data.message) {
    //     alert(error.response.data.message)
    //   }
    // },
  });
};

export const GetcustomerDetails = () => {
  const queryClient = useQueryClient();
  return useMutation(({ body }) => getCustomerDetailsforSingup(body), {
    onSuccess: (res) => {
      queryClient.invalidateQueries("GetCustomerdataformsearch");
    },
  });
};

export const GetAuthVerificationMethod = ()=>{
  return useQuery(
     ["auth-verification-method-users", { }],
     () => getAuthVerificationMethod(),
     {
       keepPreviousData: true,
       staleTime: 60 * 60 * 1000,
     }
   );
}
export const GetVerificationMethod = ()=>{
  return useQuery(
     ["verification-method-users", { }],
     () => getVerificationMethod(),
     {
       keepPreviousData: true,
       staleTime: 60 * 60 * 1000,
     }
   );
}